"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCampaignServiceCreativeRequestToJSON = exports.CreateCampaignServiceCreativeRequestFromJSONTyped = exports.CreateCampaignServiceCreativeRequestFromJSON = exports.instanceOfCreateCampaignServiceCreativeRequest = exports.CreateCampaignServiceCreativeRequestCreativeTypeEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.CreateCampaignServiceCreativeRequestCreativeTypeEnum = {
    Audio: 'AUDIO',
    Video: 'VIDEO',
    Image: 'IMAGE'
};
/**
 * Check if a given object implements the CreateCampaignServiceCreativeRequest interface.
 */
function instanceOfCreateCampaignServiceCreativeRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "creativeType" in value;
    isInstance = isInstance && "assetId" in value;
    isInstance = isInstance && "flightId" in value;
    return isInstance;
}
exports.instanceOfCreateCampaignServiceCreativeRequest = instanceOfCreateCampaignServiceCreativeRequest;
function CreateCampaignServiceCreativeRequestFromJSON(json) {
    return CreateCampaignServiceCreativeRequestFromJSONTyped(json, false);
}
exports.CreateCampaignServiceCreativeRequestFromJSON = CreateCampaignServiceCreativeRequestFromJSON;
function CreateCampaignServiceCreativeRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'brandName': !(0, runtime_1.exists)(json, 'brand_name') ? undefined : json['brand_name'],
        'creativeType': json['creative_type'],
        'assetId': json['asset_id'],
        'companionIds': !(0, runtime_1.exists)(json, 'companion_ids') ? undefined : json['companion_ids'],
        'surveyId': !(0, runtime_1.exists)(json, 'survey_id') ? undefined : json['survey_id'],
        'logoImageId': !(0, runtime_1.exists)(json, 'logo_image_id') ? undefined : json['logo_image_id'],
        'flightId': json['flight_id'],
        'language': !(0, runtime_1.exists)(json, 'language') ? undefined : json['language'],
    };
}
exports.CreateCampaignServiceCreativeRequestFromJSONTyped = CreateCampaignServiceCreativeRequestFromJSONTyped;
function CreateCampaignServiceCreativeRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'brand_name': value.brandName,
        'creative_type': value.creativeType,
        'asset_id': value.assetId,
        'companion_ids': value.companionIds,
        'survey_id': value.surveyId,
        'logo_image_id': value.logoImageId,
        'flight_id': value.flightId,
        'language': value.language,
    };
}
exports.CreateCampaignServiceCreativeRequestToJSON = CreateCampaignServiceCreativeRequestToJSON;
